module.exports = __webpack_public_path__ + "img/activePagePcBgEn.98e9a8a0.png";